import axios from 'axios';

const getConfig = () => {
    const token = sessionStorage.getItem("tokenBearer");
    if (!token) {
        throw new Error("Token no disponible en sessionStorage");
    }
    return {
        headers: { 
            Authorization: `Bearer ${token}`,
            'X-OrigenId': '9',
            'X-ExodusDev': '0'
        }
    };
};

/**
 * Metodo para obtener información acerca de una sucursal
 * @param {sucursalId} getDataTipoSucursal 
 * @returns object con data de sucursal
 */
export const getDataTipoSucursal = async (sucursalId) => {
    const config = getConfig();
    return await axios.get(process.env.REACT_APP_SUCURSALESSERVICE+""+sucursalId.toString()+"/Negocio", config)
    .catch(function (error) {
        if (error.response) {
            return false;
        }
    });
}